<div class="nav-container">
  <nav class="navbar navbar-expand-md navbar-light bg-light">
    <div class="container">
      <img title="logo" [routerLink]="['/']" style="cursor: pointer;" src="./assets/images/simmons_logo.svg">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" [attr.aria-expanded]="!isCollapsed" aria-label="Toggle navigation"
        (click)="toggleCollapsed()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <ng-container *ngIf="!isHidden && auth.loggedIn && false">
      <mat-form-field  style="display:flex; flex-direction: column; width: 35%; padding-left: 10%;">
        <mat-label>Search by Name [Last, First] or Institution ID</mat-label>
        <input (keyup)="this.isOpen=true;"  matInput maxlength="25" cdkOverlayOrigin #trigger="cdkOverlayOrigin"
          autofocus="true" autocomplete="off" placeholder="Search by Name [Last, First] or Institution ID."
          id="txtSearch" (keyup.enter)="search()" 
          #input>
          <mat-icon (click)="search()" matSuffix>search</mat-icon>
      </mat-form-field>
      <ng-template cdkConnectedOverlay cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
        [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen"
        (detach)="isOpen = false" (backdropClick)="isOpen = false">
        <div cdkTrapFocus [cdkTrapFocusAutoCapture]="true">          
          <table  mat-table [dataSource]="dataSource"  style="width: 24vw; background-color: #f8f9fa">
            <ng-container matColumnDef="institutionId">
              <th mat-header-cell *matHeaderCellDef> Institution ID </th>
              <td mat-cell *matCellDef="let element"> {{element.institutionId | mask: '00-000-0000'}} </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef> Name </th>
              <td mat-cell *matCellDef="let element"> {{element.lastName}}, {{element.firstName}} {{element.middleName}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="view(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
           </table>
          <!-- <mat-paginator  #paginator [length]="studentCount" [pageIndex]="this.searchFilter.page" [pageSize]="this.searchFilter.pageSize"
             [pageSizeOptions]="[20,30,40,50,100]" (page)="pageChanged($event)">
          </mat-paginator> -->
           <!-- <mat-paginator [length]="studentCount" [pageSizeOptions]="[5,10,20,30,40,50,100]"></mat-paginator> -->
        </div>
      </ng-template>
      </ng-container>
      <div class="collapse navbar-collapse" id="navbarNav"
        [ngClass]="{'collapse': isCollapsed, 'navbar-collapse': true}">
        <ul class="navbar-nav mr-auto">
        </ul>
        <ul class="navbar-nav" *ngIf="auth.loggedIn">
          <li class="nav-item" hidden>
            <a class="nav-link text-dark" [routerLink]="['/']">Home</a>
          </li>
          <!-- <li class="nav-item" [routerLinkActive]="['/dashboard']">
            <a class="nav-link text-dark" [routerLink]="['/dashboard']">Dashboard</a>
          </li> -->
          <li class="nav-item" *ngIf="ReadDocuments" [routerLinkActive]="['/dashboard/documents']">
            <a class="nav-link text-dark" [routerLink]="['/dashboard/documents']">My Documents</a>
          </li>
          <li class="nav-item" *ngIf="ReadStudentSearch" [routerLinkActive]="['/student-search']">
            <a class="nav-link text-dark" [routerLink]="['/student-search']">Student Search</a>
          </li>
          <li class="nav-item" *ngIf="ReadSummary" [routerLinkActive]="['/summary']">
            <a class="nav-link text-dark" [routerLink]="['/summary']">Summary</a>
          </li>
          <li class="nav-item" *ngIf="ReadApr" [routerLinkActive]="['/apr']">
            <a class="nav-link text-dark" [routerLink]="['/apr']">APR</a>
          </li>
          <li class="nav-item" *ngIf="ReadCertification" [routerLinkActive]="['/certification']">
            <a class="nav-link text-dark" [routerLink]="['/certification']">Certification</a>
          </li>
          <li class="nav-item" *ngIf="ReadReports" [routerLinkActive]="['/reports']">
            <a class="nav-link text-dark" [routerLink]="['/reports']">Reports</a>
          </li>
          <li class="nav-item" *ngIf="ReadMaintenance" [routerLinkActive]="['/maintenance']">
            <a class="nav-link text-dark" [routerLink]="['/maintenance']">Maintenance</a>
          </li>          
          <li class="nav-item" [routerLinkActive]="['profile']">
            <a class="nav-link text-dark" [routerLink]="['/profile']">Profile</a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-dark" style="cursor: pointer;" (click)="logout()">
              <mat-icon colour="primary" aria-label="Logout">logout</mat-icon>
            </a>
          </li>
        </ul>
        <ul class="navbar-nav" *ngIf="!auth.loggedIn">
          <li class="nav-item">
            <button mat-raised-button (click)="auth.login()" color="primary">LOG IN</button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>